import { SIMULATE_LDAP_GROUPS_STORAGE_KEY } from '../types/constants';
import { hasLength } from '../utils/dataTransformations';
import { ldapGroupsToStored } from '../utils/ldapGroups';

const storedSimulation = (): string | null =>
  localStorage.getItem(SIMULATE_LDAP_GROUPS_STORAGE_KEY);

const clearSimulation = (): void => {
  localStorage.removeItem(SIMULATE_LDAP_GROUPS_STORAGE_KEY);
};

// Reloading refetches the user and every page's data under the new permissions.
const startSimulation = (groups: string[]): void => {
  localStorage.setItem(SIMULATE_LDAP_GROUPS_STORAGE_KEY, ldapGroupsToStored(groups));
  window.location.reload();
};

const stopSimulation = (): void => {
  clearSimulation();
  window.location.reload();
};

/** Simulates the given groups, or restores the real groups when none are given. */
const switchSimulation = (groups: string[]): void =>
  hasLength(groups) ? startSimulation(groups) : stopSimulation();

export default {
  storedSimulation,
  clearSimulation,
  switchSimulation,
};
